'use strict';

var isMotionValue = require('../../../../../../../motion-dom/dist/es/value/utils/is-motion-value.cjs');

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
    return isMotionValue.isMotionValue(value) ? value.get() : value;
}

exports.resolveMotionValue = resolveMotionValue;
//# sourceMappingURL=resolve-motion-value.cjs.map
